export enum WebView {
    DESKTOP_VIEW,
    TAB_VIEW,
    PHONE_VIEW,
}
